enum Currency {
    USD = 'USD',
    CAD = 'CAD',
}

const CountryToCurrencyMap = new Map<string, string>([
    ['US', Currency.USD],
    ['CA', Currency.CAD],
    ['us', Currency.USD],
    ['ca', Currency.CAD],
]);

export { Currency, CountryToCurrencyMap };
